import React from "react";
import {
  Box,
  TextField,
  Typography,
  IconButton,
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltOffOutlinedIcon from "@mui/icons-material/FilterAltOffOutlined";
import RotateLeftOutlinedIcon from "@mui/icons-material/RotateLeftOutlined";
import SearchIcon from "@mui/icons-material/Search";

const FilterComponent = ({
  showFilters,
  setShowFilters,
  estoqueAtual,
  estoqueOC,
  setEstoqueAtual,
  setEstoqueOC,
  filterText,
  setFilterText,
  handleResetFilters,
  canaisVenda,
  selectedChannel,
  setSelectedChannel,
  selectedDeposito,
  setSelectedDeposito,
  statusFilter,
  setStatusFilter,
  depositos,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  onSearch,
}) => {
  const handleEstoqueAtualChange = (field, value) => {
    setEstoqueAtual((prev) => ({
      ...prev,
      [field]: value ? Math.max(0, Math.min(10000, parseInt(value))) : "",
    }));
  };

  const handleEstoqueOCChange = (field, value) => {
    setEstoqueOC((prev) => ({
      ...prev,
      [field]: value ? Math.max(0, Math.min(2500, parseInt(value))) : "",
    }));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        style={{
          backgroundColor: "white",
          marginBottom: "10px",
          display: "flex",
          flexDirection: "column",
          borderRadius: 8,
          padding: "10px",
        }}
      >
        {/* Linha principal dos filtros */}
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 10,
          }}
        >
          <TextField
            style={{
              width: "25%",
              marginLeft: 20,
              backgroundColor: "#fd947c78",
              borderRadius: 8,
            }}
            size="small"
            label="Buscar (Código ou Descrição)"
            variant="outlined"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                onSearch();
              }
            }}
            placeholder="Digite para buscar..."
          />

          <DatePicker
            label="Data Inicial"
            value={startDate}
            onChange={(newValue) => setStartDate(newValue)}
            slotProps={{
              textField: { size: "small", style: { width: "15%" } },
            }}
            format="DD/MM/YYYY"
          />

          <DatePicker
            label="Data Final"
            value={endDate}
            onChange={(newValue) => setEndDate(newValue)}
            slotProps={{
              textField: { size: "small", style: { width: "15%" } },
            }}
            format="DD/MM/YYYY"
          />

          <Autocomplete
            options={canaisVenda}
            getOptionLabel={(option) => option.label}
            value={selectedChannel}
            onChange={(event, newValue) => setSelectedChannel(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Canais de Venda"
                variant="outlined"
                size="small"
              />
            )}
            size="small"
            style={{ width: "12%" }}
          />

          {/* FILTRO DE LOCAL/DEPÓSITO DESABILITADO */}
          {/* <FormControl size="small" style={{ width: "12%" }}>
            <InputLabel>Depósito</InputLabel>
            <Select
              value={selectedDeposito}
              onChange={(e) => setSelectedDeposito(e.target.value)}
              label="Depósito"
            >
              <MenuItem value="all">Todos</MenuItem>
              {depositos.map((dep) => (
                <MenuItem key={dep} value={dep}>
                  {dep}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}

          <FormControl size="small" style={{ width: "12%" }}>
            <InputLabel>Status</InputLabel>
            <Select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              label="Status"
            >
              <MenuItem value="all">Todos</MenuItem>
              <MenuItem value="active">Ativos</MenuItem>
              <MenuItem value="inactive">Inativos</MenuItem>
            </Select>
          </FormControl>

          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            onClick={onSearch}
            sx={{
              bgcolor: "#2196f3",
              "&:hover": { bgcolor: "#1976d2" },
              height: 40,
            }}
          >
            Buscar
          </Button>

          <Box style={{ marginLeft: "auto", display: "flex" }}>
            <IconButton onClick={() => setShowFilters(!showFilters)}>
              <FilterAltOutlinedIcon />
            </IconButton>
            <IconButton onClick={() => setShowFilters(false)}>
              <FilterAltOffOutlinedIcon />
            </IconButton>
            <IconButton onClick={handleResetFilters}>
              <RotateLeftOutlinedIcon />
            </IconButton>
          </Box>
        </Box>

        {/* Linha de filtros adicionais */}
        <Box
          style={{
            backgroundColor: "white",
            height: 60,
            display: showFilters ? "flex" : "none",
            flexDirection: "row",
            alignItems: "center",
            borderRadius: 8,
            marginTop: 10,
            marginLeft: 20,
          }}
        >
          {/* Estoque Atual */}
          <Box style={{ width: "20%", marginRight: 20 }}>
            <Typography variant="body2" gutterBottom>
              Estoque Atual
            </Typography>
            <Box display="flex" gap={1}>
              <TextField
                label="Min"
                type="number"
                value={estoqueAtual.min}
                onChange={(e) =>
                  handleEstoqueAtualChange("min", e.target.value)
                }
                size="small"
                variant="outlined"
                inputProps={{ min: 0, max: 10000 }}
                style={{ width: "50%" }}
              />
              <TextField
                label="Max"
                type="number"
                value={estoqueAtual.max}
                onChange={(e) =>
                  handleEstoqueAtualChange("max", e.target.value)
                }
                size="small"
                variant="outlined"
                inputProps={{ min: 0, max: 10000 }}
                style={{ width: "50%" }}
              />
            </Box>
          </Box>

          {/* Estoque OC */}
          <Box style={{ width: "20%" }}>
            <Typography variant="body2" gutterBottom>
              Estoque OC
            </Typography>
            <Box display="flex" gap={1}>
              <TextField
                label="Min"
                type="number"
                value={estoqueOC.min}
                onChange={(e) => handleEstoqueOCChange("min", e.target.value)}
                size="small"
                variant="outlined"
                inputProps={{ min: 0, max: 2500 }}
                style={{ width: "50%" }}
              />
              <TextField
                label="Max"
                type="number"
                value={estoqueOC.max}
                onChange={(e) => handleEstoqueOCChange("max", e.target.value)}
                size="small"
                variant="outlined"
                inputProps={{ min: 0, max: 2500 }}
                style={{ width: "50%" }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default FilterComponent;
